import ColorPicker from '@/components/ColorPicker.vue';
import TextSettings from '@/components/Widget/TextSettings.vue';
import WidgetSettingsLayout from '@/components/Widget/WidgetSettingsLayout.vue';

export default {
	components: { ColorPicker, TextSettings, WidgetSettingsLayout },
	beforeRouteLeave(to, from, next) {
		if(!this.hasUnsavedChanges) return next();
		this.$refs.layout.showLeaveModal(next, () => this.save());
	},
	data() { return {
		loading: 0,
		saving: 0,
		saveError: null,
		settings: null,
		savedSettingsJson: null,
	}; },
	computed: {
		hasUnsavedChanges() {
			if(this.savedSettingsJson === null) return false;
			return JSON.stringify(this.settings) !== this.savedSettingsJson;
		},
	},
	async mounted() {
		window.addEventListener('beforeunload', this._onBeforeUnload);
		try {
			this.loading++;
			const s = await this.$api.get(`widgetSettings/${this.widgetType}`);
			this.settings = {
				label:             s.label             ?? '',
				showLabel:         s.showLabel          ?? true,
				hideCurrency:      s.hideCurrency       ?? false,
				hideAvatar:        s.hideAvatar         ?? false,
				fontFamily:        s.fontFamily         || '',
				customFont:        s.customFont         || false,
				fontSize:          s.fontSize           || 0,
				letterSpacing:     s.letterSpacing      || 0,
				textAlign:         s.textAlign          || 'left',
				boldText:          s.boldText           || false,
				italicText:        s.italicText         || false,
				underlineText:     s.underlineText      || false,
				strikethroughText: s.strikethroughText  || false,
				uppercaseText:     s.uppercaseText      || false,
				textColor:         s.textColor          || 'rgba(255,255,255,1)',
				blurRadius:        s.blurRadius         || 0,
				spreadRadius:      s.spreadRadius       || 0,
				shadowColor:       s.shadowColor        || 'rgba(0,0,0,1)',
				verticalAlign:     s.verticalAlign      || 'middle',
				extraCSS:          s.extraCSS           || '',
			};
			this.savedSettingsJson = JSON.stringify(this.settings);
		} catch(e) {
			this.saveError = e;
		} finally {
			this.loading--;
		}
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this._onBeforeUnload);
	},
	methods: {
		_onBeforeUnload(e) {
			if(this.hasUnsavedChanges) { e.preventDefault(); e.returnValue = ''; }
		},
		async save() {
			try {
				this.saving++;
				this.saveError = null;
				await this.$api.post(`widgetSettings/${this.widgetType}`, this.settings);
				this.savedSettingsJson = JSON.stringify(this.settings);
			} catch(e) {
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
